import { type FunctionComponent } from "react";
import { StarFilledIcon } from "@App/Components/common/Icons";
import { MarkerIconProps } from "@App/Components/atoms/map/markerIcons/MarkerIconProps";

export const DefaultMarkerIcon: FunctionComponent<MarkerIconProps> = ({
  state,
  rating,
  children,
  onClick,
}: MarkerIconProps) => {
  return (
    <button
      data-testid="garage-map-marker"
      className={`text-md flex items-center bg-white rounded-full shadow shadow-black-400 text-nowrap p-1 cursor-pointer ${state === "clicked" ? "ring-2 ring-blue-500" : ""}`}
      onClick={onClick}
    >
      {rating && (
        <div className="flex items-center pr-1 border-r border-gray-300">
          <StarFilledIcon className="h-5 w-5 mt-0.5 text-yellow-500" />
          <span className="font-bold text-gray-800">{rating}</span>
        </div>
      )}
      <div className="pl-1">
        <div className="text-gray-700">{children}</div>
      </div>
    </button>
  );
};
